import { render, staticRenderFns } from "./DasherRankDetails.vue?vue&type=template&id=0a548dc0&scoped=true"
import script from "./DasherRankDetails.vue?vue&type=script&lang=js"
export * from "./DasherRankDetails.vue?vue&type=script&lang=js"
import style0 from "./DasherRankDetails.vue?vue&type=style&index=0&id=0a548dc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a548dc0",
  null
  
)

export default component.exports